export class DiscountVoucherModel {
    DiscountVoucherID!:number;
    StoreID!:number;
    VoucherCode!:string;
    Discount!:number;
    StartDate!:Date;
    EndDate!:Date;
    RedeemedDate!:Date;
    SalesOrderID!:number;
    Description!:string;

    CreatedDate!:Date;
    ModifiedDate!:Date;
    Status!:number;
    IsActive!:boolean;
    OwnerID!:string;
    ModifiedBy!:string;
    CreatedBy!:string;
}